
export const environment = {
  production: false,
  //apiEndpoint: 'http://127.0.0.1:8082/'
  //apiEndpoint: 'http://192.168.4.122:8082/'
  apiEndpoint: 'https://backend.v6card.com/'
};